<template>
    <div class="container">
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <div class="content c-top">
            <div style="display: flex">
                <div class="info1">积分商城</div>
                <div class="info1" style="margin-left: 7px">/</div>
                <div>
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item v-for="(item, index) in btns" :index="index.toString()" :key="index">{{
                            item }}</el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div v-if="activeIndex == '0'">
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="商品编号" prop="goodsNo">
                        <el-input style="width: 232px" v-model="searchForm.goodsNo" placeholder="请输入商品编号"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="title">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="增加时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="已启用" value="1"></el-option>
                            <el-option label="已禁用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="title">
                    <h3>列表数据</h3>
                    <div>
                        <el-button type="primary" @click="options('add')" size="small"
                            icon="el-icon-plus">增加积分商品</el-button>
                    </div>
                </div>
                <div id="base-list" style="margin-top: 20px;">
                    <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination
                        :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                        :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="page.pageNo" :page-size="page.pageSize"
                        @selection-change="onMultipleSelection" @size-change="handleSizeChange"
                        @p-current-change="handleCurrentChange">
                    </lb-table>
                </div>
            </div>
            <div v-if="activeIndex == '1'">
                <div class="title2" style="margin-top: 18px;">新用户注册送积分</div>
                <div style="display: flex;">
                    <div class="content2">新会员注册成功后获得</div>
                    <div><el-input size="small" v-model="userForm.regUserPoints"
                            style="width: 442px;margin-left:8px;margin-right: 8px;" placeholder="请输入积分值"></el-input></div>
                    <div class="content2">积分</div>
                </div>
                <div class="title2">分享新用户获得</div>
                <div style="display: flex;">
                    <div class="content2">邀请新用户注册获得</div>
                    <div><el-input size="small" v-model="userForm.inviteUserPoints"
                            style="width: 442px;margin-left:8px;margin-right: 8px;" placeholder="请输入积分值"></el-input></div>
                    <div class="content2">积分</div>
                </div>
                <div class="title2">充值送积分</div>
                <div style="display: flex;">
                    <el-radio v-model="userForm.rechargeFlag" label="1"
                        @click.native.prevent="change(userForm.rechargeFlag)">充值送积分（按1:1赠送）</el-radio>
                </div>
                <div class="title2">好评送积分</div>
                <div style="display: flex;margin-top: 18px;">
                    <div class="content2">五星好评获得</div>
                    <div><el-input size="small" v-model="userForm.star5Points"
                            style="width: 442px;margin-left:8px;margin-right: 8px;" placeholder="请输入积分值"></el-input></div>
                    <div class="content2">积分</div>
                </div>
                <div style="display: flex;margin-top: 18px;">
                    <div class="content2">四星好评获得</div>
                    <div><el-input size="small" v-model="userForm.star4Points"
                            style="width: 442px;margin-left:8px;margin-right: 8px;" placeholder="请输入积分值"></el-input></div>
                    <div class="content2">积分</div>
                </div>
                <div style="height: 20px;"></div>
            </div>
            <div v-if="activeIndex == '2'">
                <el-form :inline="true" :model="searchForm1" ref="searchForm1" size="small">
                    <el-form-item label="用户信息" prop="userInfo">
                        <el-input style="width: 232px" v-model="searchForm1.userInfo" placeholder="请输入用户信息"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="兑换商品" prop="goodsInfo">
                        <el-input style="width: 232px" v-model="searchForm1.goodsInfo" placeholder="请输入商品信息"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="兑换时间" prop="createdTimeStart">
                        <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="兑换订单" prop="orderNo">
                        <el-input style="width: 232px" v-model="searchForm1.orderNo" placeholder="请输入订单信息"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData1('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData1('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="title">
                    <h3>列表数据</h3>
                    <div>
                        <el-button type="primary" @click="exportData()" size="small" icon="el-icon-upload">导出</el-button>
                    </div>
                </div>
                <div id="base-list" style="margin-top: 20px;">
                    <lb-table v-horizontal-scroll="'always'" :column="columns1" :data="list1" pagination
                        :total="page1.totalNum" layout="total, sizes, prev, pager, next, jumper"
                        :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="page1.pageNo" :page-size="page1.pageSize"
                        @size-change="handleSizeChange1" @p-current-change="handleCurrentChange1">
                    </lb-table>
                </div>
            </div>
        </div>
        <el-button v-if="activeIndex == '1'" type="primary" @click="save()"
            style=" width: 184px;height: 40px;border-radius: 3px;font-size: 18px;background: #2D46EE;">保存</el-button>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="提示信息" :visible.sync="isS" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left" v-if="statusS == '0'">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否操作为【启用】状态？
                </div>
                <div class="info" style="text-align: left" v-else>
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否操作为【禁用】状态？
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isS = false">取消</div>
                    <div class="info-s" @click="submitA">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="轮播图上传" :visible.sync="isL" width="800px" :append-to-body="true">
            <el-form ref="form" label-width="100px" class="info-form" style="margin-top: 22px" :model="form">
                <el-form-item label="轮播图" prop="banner">
                    <label slot="label">轮播图({{
                        fileList.length
                    }}/5)</label>
                    <upload-picture :limit="5" :list="fileList" @changeImage="changeImage" />

                </el-form-item>
                <el-form-item>
                    <div class="p-info">图片尺寸：建议上传750px*400px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isL = false">取消</div>
                <div class="info-s" @click="submitL">确定</div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
import uploadPicture from '@/components/upload/dragpicture1.vue'
export default {
    components: {
        breadcrumbTop,
        LbTable,
        uploadPicture
    },
    data() {
        return {
            selectD: [],
            fileList: [],
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '积分商城', path: '', type: '1' },
                ]
            },
            activeIndex: '0',
            btns: ['积分商品', '积分设置', '兑换明细'],
            searchForm: {
                name: '',
                goodsNo: '',
                pageNo: 1,
                pageSize: 10,
                createdTimeStart: '',
                createdTimeEnd: '',
                status: ''
            },
            userForm: {
                inviteUserPoints: '',
                star4Points: '',
                star5Points: '',
                rechargeFlag: '0',
                regUserPoints: ''

            },
            searchForm1: {
                goodsInfo: '',
                orderNo: '',
                pageNo: 1,
                pageSize: 10,
                payTimeEnd: '',
                payTimeStart: '',
                userInfo: ''
            },
            value1: [],
            value2: [],
            columns: [
                {
                    label: '商品信息',
                    width: '400',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;">
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                                <div style="text-align:left;flex:1;">
                                    <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                                        {scope.row.goodsName}
                                    </div>
                                    <p>商品编号：{scope.row.goodsNo || '--'}</p>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    label: '所需积分', prop: 'title1', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>{scope.row.pointMin}~{scope.row.pointMax}</div>
                        )
                    }
                },
                { label: '库存', prop: 'stock', minWidth: '100' },
                { label: '增加时间', prop: 'createdTime', minWidth: '100' },
                {
                    label: '商品状态', prop: 'goodsStatusLabel', minWidth: '130',
                },

                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {
                        let vv = ''
                        if (scope.row.statusLabel == '已启用') {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        } else {
                            vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:center;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                                <div>{scope.row.statusLabel}</div>
                            </p>
                        }
                        return (
                            <div> {vv}</div>
                        )
                    }
                },

                {
                    label: '操作',
                    minWidth: '80',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row.goodsId, scope.row.id, scope.row.goodsType, scope.row.goodsName) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.updateStatus(scope.row) }}>{scope.row.statusL}</span>
                            </div >
                        )
                    }
                }],
            columns1: [
                {
                    label: '兑换用户',
                    width: '200',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;">
                                <div style="text-align:left;flex:1;">
                                    <p>昵称：{scope.row.userName || '--'}</p>
                                    <p>ID：{scope.row.userId || '--'}</p>
                                    <p>电话：{scope.row.userPhone || '--'}</p>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    label: '兑换商品',
                    width: '400',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;">
                                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                                <div style="text-align:left;flex:1;">
                                    <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                                        {scope.row.goodsName}
                                    </div>
                                    <p>商品编号：{scope.row.goodsSkuName || '--'}</p>
                                </div>
                            </div>
                        )
                    }
                },
                { label: '兑换个数', prop: 'goodsQuantity', minWidth: '100' },
                { label: '兑换积分', prop: 'costPoints', minWidth: '100' },
                { label: '兑换时间', prop: 'payTime', minWidth: '100' },
                { label: '兑换订单', prop: 'orderNo', minWidth: '100' },
            ],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            list: [

            ],
            list1: [],
            isD: false,
            isS: false,
            isL: false,
            form: {
                banner: '',
            },
            statusS: '',
            uId: ''
        }
    },
    created() {
        // this.getType()
        // this.getPageList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addOrEditComment') {
            next(vm => {
                // vm.getType()
                vm.getPageList();
            });
        } else {
            next(vm => {
                // vm.getType()
                vm.getPageList();
            });
        }
    },
    methods: {
        //导出数据
        exportData() {
            this.axios.post('/point/goods/orderPageListExport', this.searchForm1).then(res => {
                if (res.code == 0) {
                    // this.exportLoading = false
                    this.$message.success('导出成功')
                    this.downloadlink(res.data)
                }
            })
        },
        downloadlink(url) {
            const protocol = location.protocol
            let resultUrl = url
            if (protocol === 'https:') {
                resultUrl = url.replace(`http:`, `${protocol}`)
            }
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = resultUrl
            document.body.appendChild(iframe)
        },
        change(val) {
            this.userForm.rechargeFlag = val == 1 ? '0' : '1'
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
                this.searchForm.name = ''
                this.searchForm.goodsNo = ''
                this.searchForm.status = ''
            }
            this.getPageList()
        },
        fetchData1(type) {
            this.page1.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm1'].resetFields()
                this.value2 = []
                this.searchForm.payTimeStart = ''
                this.searchForm.payTimeEnd = ''
                this.searchForm.goodsInfo = ''
                this.searchForm.orderNo = ''
                this.searchForm.userInfo = ''
            }
            this.getPageList1()
        },
        toArticleComment() {
            this.$router.push({
                name: 'articleComment',
                query: { goodsArticleCategoryId: Number(this.activeIndex) + 1 }
            })
        },
        options(type, goodsId, id, goodsType, goodsName) {
            this.$router.push({
                name: 'addOrEditIntegralShop',
                query: {
                    type: type,
                    goodsId: goodsId,
                    id: id,
                    goodsType: goodsType,
                    goodsName: goodsName
                }
            })
        },
        changeImage(file) {
            console.log(file)
            this.fileList = file
        },
        uploadBanner() {
            this.isL = true
            this.fileList = []
            this.getBanner()
        },
        getBanner() {
            let id = Number(this.activeIndex) + 1
            this.axios.get('/goodsArticleCategory/getLoopImages?id=' + id)
                .then(res => {
                    console.log(res, '444')
                    res.data.forEach(item => {
                        let obj = {
                            mainFlag: false,
                            url: item
                        }
                        this.fileList.push(obj)
                    })



                })
        },
        handleSelect(e) {
            console.log(e)
            this.activeIndex = e
            if (this.activeIndex == 0) {
                this.page.pageNo = 1
                // this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
                this.searchForm.name = ''
                this.searchForm.status = ''
                this.searchForm.goodsNo = ''
                this.getPageList()
            } else if (this.activeIndex == 1) {
                this.getSetting()
            } else {
                this.page1.pageNo = 1
                // this.$refs['searchForm1'].resetFields()
                this.value2 = []
                this.searchForm.payTimeStart = ''
                this.searchForm.payTimeEnd = ''
                this.searchForm.goodsInfo = ''
                this.searchForm.orderNo = ''
                this.searchForm.userInfo = ''
                this.getPageList1()
            }

        },
        getSetting() {
            this.axios.get('/point/goods/getSetting')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.rechargeFlag = String(res.data.rechargeFlag)
                        this.userForm = res.data
                    }

                })
        },
        save() {
            this.axios.post('/point/goods/editSetting', this.userForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('保存成功')
                        this.getSetting()
                    }

                })
        },
        getType() {
            // this.axios.post('/goodsArticleCategory/pageList', {
            //     pageNo: 1,
            //     pageSize: 2000
            // }).then(res => {
            //     console.log(res)
            //     this.btns = res.data.list
            // })
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createdTimeStart = this.value1[0];
                this.searchForm.createdTimeEnd = this.value1[1];
            } else {
                this.searchForm.createdTimeStart = ''
                this.searchForm.createdTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('point/goods/getPage', this.searchForm)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        if (item.status == 1) {
                            item.statusL = '禁用'
                        } else {
                            item.statusL = '启用'

                        }
                        item.mainImageArr = []
                        if (item.imageUrl.indexOf(',') != -1) {
                            item.mainImageArr = item.imageUrl.split(',')
                        } else {
                            item.mainImageArr.push(item.imageUrl)
                        }
                        // item.mainImageArr.push(item.mainImg.split(',')[0])
                    })
                    this.list = res.data.list;
                    this.page.totalNum = res.data.totalNum;
                })
        },
        getPageList1() {
            if (this.value2 && this.value2.length > 0) {
                this.searchForm.payTimeStart = this.value2[0];
                this.searchForm.payTimeEnd = this.value2[1];
            } else {
                this.searchForm.payTimeStart = ''
                this.searchForm.payTimeEnd = ''
            }
            this.searchForm1.pageNo = this.page1.pageNo;
            this.searchForm1.pageSize = this.page1.pageSize;
            this.axios.post('/point/goods/getOrderPage', this.searchForm1)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        item.mainImageArr = []
                        if (item.goodsImageUrl.indexOf(',') != -1) {
                            item.mainImageArr = item.goodsImageUrl.split(',')
                        } else {
                            item.mainImageArr.push(item.goodsImageUrl)
                        }
                        // item.mainImageArr.push(item.mainImg.split(',')[0])
                    })
                    this.list1 = res.data.list;
                    this.page1.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) {
            console.log(e)
            this.selectD = e
        },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        handleSizeChange1(e) {
            this.page1.pageSize = e;
            this.page1.pageNo = 1;
            this.getPageList1()
        },
        handleCurrentChange1(e) {
            this.page1.pageNo = e;
            this.getPageList1()
        },
        updateStatus(row) {
            this.isS = true
            this.statusS = row.status
            this.uId = row.id
        },
        deleteD(row) {
            this.isD = true
            this.selectD.push(row)
        },
        deleteAll() {
            if (this.selectD.length > 0) {
                this.isD = true
            } else {
                this.$message.error('请选择要删除的数据')
            }
        },
        submitA() {
            let status = ''
            if (this.statusS == 1) {
                // status = 0
                let ids = []
                ids.push(this.uId)
                let data = {
                    ids: ids,
                }
                this.axios.post('/point/goods/disable', data).then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('更改成功')
                        this.getPageList()
                        this.isS = false
                    }
                })

            } else {
                // status = 1
                let ids = []
                ids.push(this.uId)
                let data = {
                    ids: ids,
                }
                this.axios.post('/point/goods/enable', data).then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('更改成功')
                        this.getPageList()
                        this.isS = false
                    }
                })
            }
            // let data = {
            //     goodsArticleId: this.uId,
            //     status: status
            // }
            // this.axios.post('/goodsArticle/toggle', data).then(res => {
            //     console.log(res)
            //     if (res.code == 0) {
            //         this.$message.success('更改成功')
            //         this.getPageList()
            //         this.isS = false
            //     }
            // })
        },
        submitD() {
            let goodsArticleIds = []
            this.selectD.forEach(item => {
                goodsArticleIds.push(item.id)
            })
            let data = {
                goodsArticleIds: goodsArticleIds

            }
            this.axios.post('/goodsArticle/delete', data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.$message.success('删除成功')
                    this.getPageList()
                    this.isD = false
                }
            })
        },
        submitL() {
            let loopImgs = []
            this.fileList.forEach(item => {
                loopImgs.push(item.url)
            })
            let data = {
                goodsArticleCategoryId: Number(this.activeIndex) + 1,
                loopImgs: loopImgs
            }
            this.axios.post('/goodsArticleCategory/saveLoopImages', data).then(res => {
                console.log(res)
                if (res.code == 0) {
                    this.$message.success('修改成功')
                    this.isL = false
                }
            })
        }
    }


}
</script>
<style lang="scss" scoped>
.p-info {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #909099;
    margin-bottom: 18px
}

.info1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 0px;
    color: #303033;
    line-height: 60px;
}

.el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 2px solid #2d46ee;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303033;
}

.el-menu.el-menu--horizontal {
    border-bottom: none;
}

.el-menu--horizontal>.el-menu-item {
    height: 44px;
    line-height: 60px;
    font-size: 16px;
    margin-right: 24px;
    width: 76px;
    text-align: center;
    padding: 0;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title2 {
    width: 128px;
    height: 21px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #303033;
    line-height: 0px;
    margin-top: 36px;
}

.content2 {
    // width: 140px;
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #303033;
    line-height: 32px;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #303033;
    opacity: 1;
    text-align: center;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
</style>